module.exports = "https://cdn.hellotech.com/client-assets/computers-desktop_d790172efd21b7ac4314a822e4ccfc77.jpg";